import { propsFactory } from '@components/utils';

import type { PropType } from 'vue';

export interface IOverlayProps {
  attach: boolean | string | Element | undefined;
  contained: boolean | undefined;
  disabled: boolean | undefined;
  persistent: boolean | undefined;
  scrim: boolean | string | undefined;
  modelValue: boolean | undefined;
  zIndex: number | string | undefined;
  contentClasses: string | string[] | Record<string, boolean> | undefined;
  contentProps: Record<string, unknown> | undefined;
}

export const makeOverlayProps = propsFactory(
  {
    /**
     * Указывает, к какому DOM элементу будет прикреплен компонент.
     * По умолчанию прикрепляется к body.
     * Если передана строка, то ищет элемент по querySelector.
     * Если передан объект, то считает его допустимым Node элементом.
     */
    attach: {
      type: [Boolean, String, Object] as PropType<boolean | string | Element>,
      default: false
    },
    /**
     * Указывает, что компонент будет прикреплен к родительскому элементу. Подразумевает absolute и attach в true.
     */
    contained: {
      type: Boolean as PropType<boolean>,
      default: false
    },
    /**
     * Блокирует возможность клика или фокуса всплывающего компонента
     */
    disabled: {
      type: Boolean as PropType<boolean>,
      default: false
    },
    /**
     * Клик за пределами компонента или esc не будет закрывать его
     */
    persistent: {
      type: Boolean as PropType<boolean>,
      default: false
    },
    /**
     * Фон для компонента. Строкой можно передать цвет фона.
     */
    scrim: {
      type: [Boolean, String] as PropType<boolean | string>,
      default: true
    },
    /**
     * Значение v-model. Управляет видимостью компонента.
     */
    modelValue: {
      type: Boolean as PropType<boolean>,
      default: false
    },
    /**
     * Закрывать ли компонент при навигации назад
     */
    closeOnBack: {
      type: Boolean as PropType<boolean>,
      default: true
    },
    /**
     * Значение z-index
     */
    zIndex: {
      type: [Number, String] as PropType<number | string>,
      default: 2000
    },
    /**
     * Классы для контента компонента
     */
    contentClasses: {
      type: [String, Array, Object] as PropType<string | string[] | Record<string, boolean>>,
      default: null
    },
    /**
     * Свойства для контента компонента
     */
    contentProps: {
      type: Object as PropType<Record<string, unknown>>,
      default: () => ({})
    },
    /**
     * Отключает анимацию при клике вне контента
     */
    noClickAnimation: {
      type: Boolean as PropType<boolean>,
      default: false
    },
    /**
     * Прозрачность overlay компонента
     */
    opacity: {
      type: [Number, String] as PropType<string | number>,
      default: undefined
    }
  },
  'overlay'
);
